module.exports = {"data":{"site":{"siteMetadata":{"title":"Cappasity contest","siteUrl":"https://cappasityinc.github.io/contest-special-votes","description":"CAPP for Spin — a contest for our active community members to raise the level of awareness of the Cappasity platform and the CAPP token. Prizes — up to 120,000 CAPP"}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 98
// module chunks = 22676092666560 60335399758886